export const routerPath = {
  root: '/not-validated-classes',
  link: '/general/not-validated-classes',
};

export function getFormatList(list) {
  const filteredList = list.filter((item) => !!item?.customClasses?.length || item?.licensedClasses?.length);

  const formatList = filteredList.map((item) => {
    const customClasses = item?.customClasses?.length
      ? item.customClasses.map((itemClass) => ({
          ...itemClass,
          classType: 'Custom Class',
          facilityName: item.name,
        }))
      : [];

    const licensedClasses = item?.licensedClasses?.length
      ? item.licensedClasses.map((itemClass) => ({
          ...itemClass,
          classType: 'Licensed Class',
          facilityName: item.name,
        }))
      : [];

    return [...customClasses, ...licensedClasses];
  });

  return formatList.flat();
}

export const getColumns = ({ editItem }) => [
  {
    id: 'name',
    label: 'Class Name',
    align: 'left',
    sx: { textTransform: 'capitalize' },
  },
  {
    id: 'facilityName',
    label: 'Facility Name',
    align: 'center',
  },
  {
    id: 'classType',
    label: 'Class Type',
    align: 'center',
  },
  {
    id: 'validated',
    label: 'Validated',
    align: 'center',
    customValue: (item) => (item.validated ? 'Yes' : 'No'),
  },
  {
    id: 'edit',
    label: 'Edit',
    align: 'center',
    action: editItem,
    icon: 'eva:edit-fill',
    disableSort: true,
  },
];
